jQuery(function($) {

	/**
	* 記事中のiframeを強制的にdivで囲む
	*/

	$('.mct .section iframe:not(".reset")').wrap('<div class="u-obj-box"></div>');

	/**
	* CF7の確認画面にクラス付与
	*/
	$('input.wpcf7c-elm-step1.wpcf7c-btn-confirm').on('click',function(){
		$('.wpcf7').addClass('is_confirm');
	});
	$('input.wpcf7c-btn-back').on('click',function(){
		$('.wpcf7').removeClass('is_confirm');
	});

});